import React from 'react';
import { Header } from '../components/global/header';
import { ResetPassword } from '../components/auth/resetPassword';
import { Footer } from '../components/global/footer';

const ResetPasswordPage = () => {
  return (
    <div>
      <Header />
      <ResetPassword />
      <Footer />
    </div>
  );
};

export default ResetPasswordPage;
